module.exports = __webpack_public_path__ + "img/huwelijksdrukwerk-drukwerk-annonce-trouwen-hannah-kyle-preeg-emboss-origami-thumbnail.146618eb.png";